const initCaseStudyNav = (nav) => {
  const summary = nav.closest('.case-summary');
  const content = summary
    ? summary.parentElement.querySelector('.case-content')
    : null;
  const tabletQuery = window.matchMedia('(max-width: 1023px)');
  const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
  const items = links
    .map((link) => ({
      link,
      section: document.querySelector(link.getAttribute('href')),
    }))
    .filter((item) => item.section);

  if (!items.length) {
    return;
  }

  let activeId = null;
  let navAnchorTop = null;
  let lockedTargetId = null;
  let unlockTimer = null;
  let releaseTimer = null;

  const cancelRelease = () => {
    window.clearTimeout(releaseTimer);
    summary.classList.remove('is-nav-releasing', 'is-nav-releasing--bottom');
  };

  const releaseNav = (atBottom) => {
    if (!atBottom) {
      const fixedTop = nav.getBoundingClientRect().top;

      cancelRelease();
      summary.classList.remove('is-nav-fixed');

      const offset = fixedTop - nav.getBoundingClientRect().top;
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (!reduceMotion && Math.abs(offset) > 1 && nav.animate) {
        nav.animate(
          [
            { transform: `translateY(${offset}px)` },
            { transform: 'translateY(0)' },
          ],
          {
            duration: 260,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          }
        );
      }

      return;
    }

    if (summary.classList.contains('is-nav-releasing')) {
      return;
    }

    summary.classList.add('is-nav-releasing');
    summary.classList.add('is-nav-releasing--bottom');
    releaseTimer = window.setTimeout(() => {
      summary.classList.remove(
        'is-nav-fixed',
        'is-nav-releasing',
        'is-nav-releasing--bottom'
      );
    }, 260);
  };

  const setActive = (id) => {
    const hasChanged = activeId !== id;
    activeId = id;

    links.forEach((link) => {
      const isActive = link.getAttribute('href') === `#${id}`;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');

        if (hasChanged && tabletQuery.matches) {
          const left =
            link.offsetLeft - nav.clientWidth / 2 + link.offsetWidth / 2;
          nav.scrollTo({ left, behavior: 'smooth' });
        }
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const updateActive = () => {
    const header = document.querySelector('.header');
    const adminBar = document.querySelector('#wpadminbar');
    let headerBottom = 0;

    if (header) {
      headerBottom = header.getBoundingClientRect().bottom;
    } else if (adminBar) {
      headerBottom = adminBar.getBoundingClientRect().bottom;
    }

    if (!summary || !content || !tabletQuery.matches) {
      if (summary) {
        cancelRelease();
        summary.classList.remove('is-nav-fixed');
      }
    } else {
      const isFixed = summary.classList.contains('is-nav-fixed');

      if (!isFixed || null === navAnchorTop) {
        navAnchorTop = nav.getBoundingClientRect().top + window.scrollY;
      }

      const navTop = navAnchorTop - window.scrollY;
      const contentBottom = content.getBoundingClientRect().bottom;
      const shouldFix =
        navTop <= headerBottom &&
        contentBottom > headerBottom + nav.offsetHeight;

      summary.style.setProperty('--case-nav-height', `${nav.offsetHeight}px`);

      if (shouldFix) {
        cancelRelease();
        summary.classList.add('is-nav-fixed');
      } else if (isFixed) {
        releaseNav(contentBottom <= headerBottom + nav.offsetHeight);
      }
    }

    const activationOffset = tabletQuery.matches
      ? headerBottom +
        (summary && summary.classList.contains('is-nav-fixed')
          ? nav.offsetHeight
          : 0) +
        16
      : Math.min(window.innerHeight * 0.3, 180);
    let activeItem = items[0];

    items.forEach((item) => {
      if (item.section.getBoundingClientRect().top <= activationOffset) {
        activeItem = item;
      }
    });

    if (lockedTargetId) {
      const targetItem = items.find(
        (item) => item.section.id === lockedTargetId
      );
      const targetReached =
        targetItem &&
        Math.abs(
          targetItem.section.getBoundingClientRect().top - activationOffset
        ) <= 24;

      if (targetReached) {
        activeItem = targetItem;
        lockedTargetId = null;
        window.clearTimeout(unlockTimer);
      } else {
        setActive(lockedTargetId);
        return;
      }
    }

    setActive(activeItem.section.id);
  };

  let ticking = false;
  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(() => {
      updateActive();
      ticking = false;
    });
  };

  items.forEach(({ link, section }) => {
    link.addEventListener('click', () => {
      lockedTargetId = section.id;
      setActive(section.id);
      window.clearTimeout(unlockTimer);
      unlockTimer = window.setTimeout(() => {
        lockedTargetId = null;
        requestUpdate();
      }, 2000);
    });
  });

  updateActive();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  tabletQuery.addEventListener('change', requestUpdate);
};

document.querySelectorAll('[data-case-nav]').forEach(initCaseStudyNav);
